"use client";

import { localeStringToLocaleKey } from "@faire/web/common/consts/TWO_TO_THREE_LETTER_LANGUAGE_CODE";
import { IntlProvider } from "@faire/web/common/localization/IntlProvider";
import {
  getTranslationLocale,
  IntlMap,
} from "@faire/web/common/rsc/localization/utils";
import { isWindowUndefined } from "@faire/web/common/server-side-rendering/isWindowUndefined";
import React, { ReactNode } from "react";

export const IntlProviderForSSR_Base = ({
  children,
  locale,
}: {
  children: ReactNode;
  locale: string;
}) => {
  if (!isWindowUndefined()) {
    return children;
  }

  const localizationLocale = getTranslationLocale(locale);
  const localeKey = localeStringToLocaleKey(localizationLocale);
  const GLOBAL_INTL_MAP =
    typeof globalThis === "object" &&
    (globalThis as unknown as { GLOBAL_INTL_MAP: IntlMap }).GLOBAL_INTL_MAP;

  if (!GLOBAL_INTL_MAP) {
    throw new Error("GLOBAL_INTL_MAP is not defined");
  }

  return (
    <IntlProvider
      localeKey={localeKey}
      messages={GLOBAL_INTL_MAP[localizationLocale].messages}
    >
      {children}
    </IntlProvider>
  );
};
